import * as React from 'react';
import { format } from 'date-fns';
import { es } from 'date-fns/locale';
import { Calendar as CalendarIcon } from 'lucide-react';
import { DateRange } from 'react-day-picker';
import { Calendar } from './calendar';
import 'react-day-picker/dist/style.css';

import { Popover, PopoverContent, PopoverTrigger } from '@radix-ui/react-popover';
import { Button } from './button';

export interface DateRangeFilterProps {
  date?: DateRange;
  onChange: (date?: DateRange) => void;
  placeholder?: string;
  className?: string;
}

/**
 * DateRangeFilter
 * Componente para seleccionar un rango de fechas usando react-day-picker
 * 
 * @example
 * ```tsx
 * const [date, setDate] = useState<DateRange | undefined>();
 * 
 * return (
 *   <DateRangeFilter date={date} onChange={setDate} />
 * );
 * ```
 */
export function DateRangeFilter({ date, onChange, placeholder = 'Seleccionar fechas', className = '' }: DateRangeFilterProps) {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button
          id="date"
          variant={'outline'}
          className={`w-[280px] justify-start text-left font-normal ${!date && 'text-slate-500'} ${className}`}
        >
          <CalendarIcon className="mr-2 h-4 w-4" />
          {date?.from ? (
            date.to ? (
              <>
                {format(date.from, 'LLL dd, y', { locale: es })} -{' '}
                {format(date.to, 'LLL dd, y', { locale: es })}
              </>
            ) : (
              format(date.from, 'LLL dd, y', { locale: es })
            )
          ) : (
            <span>{placeholder}</span>
          )}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0 z-50" align="start">
        <Calendar
          mode="range"
          defaultMonth={date?.from}
          selected={date}
          onSelect={onChange}
          numberOfMonths={1}
          locale={es}
          className="rounded-md border bg-white shadow-md p-3"
        />
      </PopoverContent>
    </Popover>
  );
}
